import { CustomerEmployeesGroupService } from "./CustomerEmployeesGroupService";

export type { ICustomerEmployeesGroupService } from "./ICustomerEmployeesGroupService";

export const customerEmployeesGroupService = new CustomerEmployeesGroupService();
